var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon eyeClosed",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.536,
    height: 14.1,
    viewBox: "0 0 20.536 14.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_404",
    "data-name": "Groupe 404",
    transform: "translate(-64.64 -141.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_5",
    "data-name": "Soustraction 5",
    d: "M74.911,155.222a5.034,5.034,0,0,1-3.158-1.1l2.187-1.42a2.754,2.754,0,0,0,3.715-2.415l2.192-1.423a5.1,5.1,0,0,1-4.936,6.358Zm-4.942-3.836h0a5.1,5.1,0,0,1,4.942-6.357,5.046,5.046,0,0,1,3.154,1.1l-2.189,1.421a2.75,2.75,0,0,0-3.715,2.412l-2.191,1.423Z",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_508",
    "data-name": "Trac\\xE9 508",
    d: "M65.739,148.028a1.1,1.1,0,0,1-.883-1.755,13.658,13.658,0,0,1,8.894-5.1c3.705-.355,7.428,1.159,11.069,4.5a1.1,1.1,0,1,1-1.487,1.621c-3.162-2.9-6.311-4.229-9.373-3.93a11.5,11.5,0,0,0-7.335,4.219,1.1,1.1,0,0,1-.885.445Z",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1313",
    "data-name": "Rectangle 1313",
    width: 13.724,
    height: 1.634,
    rx: 0.816,
    transform: "translate(68.711 153.176) rotate(-33.007)",
    fill: "#181a3a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eyeClosed.70348a04e706918cd68f8fffc42b688f.svg";
export { ForwardRef as ReactComponent };